module.exports = __webpack_public_path__ + "assets/img/kj.7d00fdfa.png";